module.exports = __webpack_public_path__ + "img/poweredby_white.2cae1ffd.png";